import { B2B_PORTAL_URL, DEALER_CONSULTING_URL } from "../config";

export default function Services({ t }) {
  return (
    <section id="leistungen" className="services-section" data-testid="services-section">
      <div className="section-inner">
        <div className="section-label fade-in">{t.servicesLabel}</div>
        <h2 className="section-title fade-in">{t.servicesTitle}</h2>
        <div className="services-grid">
          {t.services.map((service, i) => (
            <div
              key={i}
              className={`service-card fade-in ${service.link ? 'has-link' : ''}`}
              style={{ transitionDelay: `${i * 0.1}s` }}
              data-testid={`service-card-${i}`}
            >
              <div className="service-number" aria-hidden="true">{service.num}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-desc">{service.desc}</p>
              {service.link && (
                <a
                  href={
                    service.link === "/b2b-portal" ? B2B_PORTAL_URL :
                    service.link === "/dealer-consulting" ? DEALER_CONSULTING_URL :
                    service.link
                  }
                  className="service-link"
                  data-testid={`service-link-${i}`}
                >
                  {service.linkText}
                </a>
              )}
              {service.comingSoon && (
                <div className="service-coming-soon" data-testid={`service-coming-soon-${i}`}>
                  {t.comingSoonText}
                </div>
              )}
              <div className="service-line" aria-hidden="true" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
